import axios from 'axios'

import { getRequestConfig } from '.'
import { GetTinkLinkRequest, GetTinkLinkResponse } from '../Interfaces/TinkPayment/TinkPaymentInterface'

export const fetchTinkLink = async (request: GetTinkLinkRequest): Promise<GetTinkLinkResponse> => {
  const url = '/subscription/tink-payment/tink-link'
  const response = await axios.post<GetTinkLinkResponse>(url, request, getRequestConfig())
  return response.data
}
